/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Coaching_Group_OpenInputs */

const en_us2_coaching_group_open = /** @type {(inputs: Coaching_Group_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open ${i?.name}`)
};

const pt_br2_coaching_group_open = /** @type {(inputs: Coaching_Group_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir ${i?.name}`)
};

const pt_pt2_coaching_group_open = /** @type {(inputs: Coaching_Group_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir ${i?.name}`)
};

/** @type {(inputs: Coaching_Group_OpenInputs) => LocalizedString} */
const es_419_coaching_group_open = en_us2_coaching_group_open;

/** @type {(inputs: Coaching_Group_OpenInputs) => LocalizedString} */
const fr_fr2_coaching_group_open = en_us2_coaching_group_open;

/** @type {(inputs: Coaching_Group_OpenInputs) => LocalizedString} */
const de_de2_coaching_group_open = en_us2_coaching_group_open;

/** @type {(inputs: Coaching_Group_OpenInputs) => LocalizedString} */
const it_it2_coaching_group_open = en_us2_coaching_group_open;

/**
* | output |
* | --- |
* | "Open {name}" |
*
* @param {Coaching_Group_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_group_open = /** @type {((inputs: Coaching_Group_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Group_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_group_open(inputs)
	if (locale === "es-419") return es_419_coaching_group_open(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_group_open(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_group_open(inputs)
	if (locale === "de-DE") return de_de2_coaching_group_open(inputs)
	if (locale === "it-IT") return it_it2_coaching_group_open(inputs)
	return en_us2_coaching_group_open(inputs)
});
export { coaching_group_open as "coaching.group_open" }